<template>
<van-overlay :show="showFlag" z-index="2000" :lock-scroll="true">
  <div class="wrapper">
     <div class="block" >
       <div v-for="(item,index) in list" :key="item.id">
          <!-- <div>
            <van-swipe :autoplay="7000" indicator-color="#C13C33" :stop-propagation="false">
              <van-swipe-item > -->
                <!-- @click="jumpTo(item)" -->
                <div class="img-box">
                  <img class="index-index-image" :src="item.imageUrl+'?x-oss-process=style/style_index_banner'"/>
                </div>
              <!-- </van-swipe-item>
            </van-swipe>
          </div> -->
          <div class="cont"><van-checkbox icon-size="15" v-model="checked" :checked-color="$theme.u_main_color_btn_bg">下次不再展示</van-checkbox></div>
          <div class="foot"><div class="button" @click="clickFun(item)">我知道了</div></div>
       </div>
    </div>
  </div>
</van-overlay>

</template>

<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
import { isWeChatApplet } from "@/utils/util";
export default {
  props: {
    code: String, //广告位编码
    groupCode: String, //广告位组编码
    refreshing: Boolean, //监听页面下拉刷新
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 690
    },
    height: {
      type: [Number, String],
      default: 180
    },
    showFlag:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [{imageUrl:'https://www.baidu.com'}],
      checked: false
    }
  },
  watch: {
    refreshing(newVal) {
      if(!newVal) {
        this.getAdData()
      }
    }
  },
  mounted() {
    this.getAdData()
  },
  methods: {
    pxToRem(value) {
      return Number(value) * 0.01333 + 'rem'
    },
    getAdData() {
      http({
        url: '/order/app/ad-position/getAdContent',
        method: 'POST',
        parmes: {
          adPositionCode: this.code,
          adPositionGroupCode: this.groupCode
        }
      }).then(({ data }) => {
        //resultStatus 1广告位不存在，2广告位不生效，3没有广告,4有广告 
        if(data.resultStatus == 4 && (data = data.adContentVO)) {
          this.$emit('adVisbelFun', true)
          this.list = data.itemList
        }
      })
    },
    clickFun({ adContentId }){
      if(this.checked){
        http({
          url: '/order/app/ad-position/handlerAdContentTrigger',
          method: 'POST',
          parmes: {
            adContentId: adContentId,
            triggerType: 'SELECTED_001'
          }
        }).then(({ data }) => {
          this.$emit('closeAdVisibelFun')
        })
      }else{
        this.$emit('closeAdVisibelFun')
      }
    },
    async jumpTo({ linkType, linkValue, adContentId }) {
      //记录点击量
      http({
        url: '/order/app/ad-position/onClick/' + adContentId,
        method: 'post'
      })

      let url, miniUrl, action={}, noTitle='0';
      let obj = {}
      switch (linkType){
        case 1: //不跳转
          return;
        case 2: //活动链接
          url = linkValue
          miniUrl = '/others/pages/navigate-webview/index?webtype=iconsDetail&weburl=' + encodeURIComponent(linkValue)
          break;
        case 3: //商品详情
          url = location.origin + '/h5user/commoditydetails?id=' + linkValue
          miniUrl = '/product/pages/product-detail/index?productid=' + linkValue
          obj = {goodsId:parseInt(linkValue)}
          action = {tm:"4030100",tp:obj}
          break;
        case 4: //店铺
          url = location.origin + '/h5user/brandIndex?id=' + linkValue
          miniUrl = '/product/pages/store-detail/index?storeid=' + linkValue
          noTitle='1';
          obj = {branchId:parseInt(linkValue)}
          action = {tm:"4090100",tp:obj}
          break;
        case 5: //话题详情
          url = location.origin + '/h5user/discoverHottopic?hotId=' + linkValue
          miniUrl = '/others/pages/navigate-webview/index?webtype=topicDetail&subjectId=' + linkValue
          break;
        case 6: //发现详情
          url = location.origin + '/h5user/discoverUserDetails?id=' + linkValue
          miniUrl = '/others/pages/find-details/index?discoverId=' + linkValue
          noTitle='1';
          break;
      }
      if(await isWeChatApplet()) {
        utils.jumpToNewPage({ url, noTitle ,action})
      } else {
        wx.miniProgram.navigateTo({ url: miniUrl })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.img-box{
  max-height: 700px;
  overflow-y:auto;
  padding: 10px 0;
}
.index-index-image{
  display: block;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 600px;
  background: #FFFFFF;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
  border-radius: 28px;
  padding-top: 40px;
}
.cont{
  margin-left: 37px;
  height: 74px;
  line-height: 74px;
}
.foot{
  border-top:1PX solid #f2f2f2;
}
.button{
  width: 600px;
  background: #FFFFFF;
  color: #007AFF;
  text-align: center;
  padding: 20px 0;
  }
</style>
